
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import documentExecutionCNContainerDialogDescriptor from './DocumentExecutionCNContainerDialogDescriptor.json'

export default defineComponent({
    name: 'document-execution-cn-container-dialog',
    components: { Dialog },
    props: { visible: { type: Boolean }, data: { type: Object } },
    emits: ['close', 'selected'],
    data() {
        return {
            documentExecutionCNContainerDialogDescriptor
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close')
        }
    }
})
